import React from 'react';
import GroupIcon from '@material-ui/icons/Group';
import PolicyRoundedIcon from '@material-ui/icons/PolicyRounded';
import VpnKeyRoundedIcon from '@material-ui/icons/VpnKeyRounded';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import MessageIcon from '@material-ui/icons/Message';
import NotificationsIcon from '@material-ui/icons/Notifications';
import BusinessIcon from '@material-ui/icons/Business';
import AddIcon from '@material-ui/icons/Add';
import ListIcon from '@material-ui/icons/List';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import QueueIcon from '@material-ui/icons/Queue';
import MovieFilterIcon from '@material-ui/icons/MovieFilter';
import SearchIcon from '@material-ui/icons/Search';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import CategoryIcon from '@material-ui/icons/Category';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import EditIcon from '@material-ui/icons/Edit';
import CommentIcon from '@material-ui/icons/Comment';
import CompareIcon from '@material-ui/icons/Compare';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import ViewListIcon from '@material-ui/icons/ViewList';
import FeaturedVideoIcon from '@material-ui/icons/FeaturedVideo';
import RadioIcon from '@material-ui/icons/Radio';
import PhotoIcon from '@material-ui/icons/Photo';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ReportIcon from '@material-ui/icons/Report';
import SlideshowIcon from '@material-ui/icons/Slideshow';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import PageviewIcon from '@material-ui/icons/Pageview';
import ArtTrackIcon from '@material-ui/icons/ArtTrack';
import ShareIcon from '@material-ui/icons/Share';
import TimelineIcon from '@material-ui/icons/Timeline';
import PublishIcon from '@material-ui/icons/Publish';
import HistoryIcon from '@material-ui/icons/History';
import RssFeedIcon from '@material-ui/icons/RssFeed';
import CastConnectedIcon from '@material-ui/icons/CastConnected';
import CastIcon from '@material-ui/icons/Cast';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList';
import FeaturedVideoOutlinedIcon from '@material-ui/icons/FeaturedVideoOutlined';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { havePermission } from './redux/reducers/identity.reducer';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import TvIcon from '@material-ui/icons/Tv';
import MovieIcon from '@material-ui/icons/Movie';
// import MovieOutlinedIcon from '@material-ui/icons/MovieOutlined';
import TvTwoToneIcon from '@material-ui/icons/TvTwoTone';

const APP_AUTOVIEW_FEATURE = [
  // autoview role
  {
    name: 'Auto Views',
    description: 'Auto Views Control',
    url: '/autoviews',
    icon: <QueuePlayNextIcon />,
  },
];

const APP_JUDGE_FEATURE_REPORT = [
  // judge role report subfeature
  {
    name: 'Judge Report',
    description: 'Collection Judge Report',
    icon: <GroupIcon />,
    url: '/reports/judge',
  },
];
const APP_JUDGE_FEATURE = [
  // judge role
];

const APP_ROOT_FEATURE = [
  // root role
  {
    name: 'Access Control',
    description: 'Access control for authorization',
    icon: <PolicyRoundedIcon />,
    url: '/access-control',
    sub: [
      {
        name: 'User',
        description: 'User Access Control',
        icon: <PersonPinIcon />,
        url: '/access-control',
      },
      {
        name: 'Group',
        description: 'Group Policies',
        icon: <GroupIcon />,
        url: '/access-control-group',
      },
      {
        name: 'Permission',
        description: 'View Permission',
        icon: <VpnKeyRoundedIcon />,
        url: '/access-control-permission',
      },
    ],
  },
  {
    name: 'Top Contributors',
    description: 'View Top Contributors',
    icon: <PermIdentityIcon />,
    url: '/top-contributor',
  },
];

const APP_FEATURES = (identity) => {
  let features = [
    // {
    //     name: 'Access Control',
    //     description: 'Access control for authorization',
    //     icon: <PolicyRoundedIcon />,
    //     url: '/access-control',
    //     sub: [
    //         {
    //             name: 'Add Group Policy',
    //             description: 'Add Group Policy',
    //             icon: <GroupIcon/>,
    //             url: '/access-control/add-group-policy'
    //         },
    //         {
    //             name: 'Search User Policies',
    //             description: 'Search User Policies',
    //             icon: <PersonPinIcon />,
    //             url: '/access-control/search-user-policies'
    //         },
    //         {
    //             name: 'Search Group Policies',
    //             description: 'Search Group Policies',
    //             icon: <PeopleOutlineIcon />,
    //             url: '/access-control/search-group-policies'
    //         },
    //         {
    //             name: 'View Permission',
    //             description: 'View Permission',
    //             icon: <VpnKeyRoundedIcon />,
    //             url: '/access-control/view-permissions'
    //         }
    //     ]
    // },
    // {
    //     name: 'Ads',
    //     description: 'Contains Ads related features',
    //     icon: <BusinessIcon />,
    //     url: '/ads',
    //     sub: [
    //         {
    //             name: 'Create Ad Location',
    //             description: 'Create Ad Location',
    //             icon: <AddIcon />,
    //             url: '/ads/create'
    //         },
    //         {
    //             name: 'List Ad Location',
    //             description: 'List Ad Location',
    //             icon: <ListIcon />,
    //             url: '/ads/list'
    //         },
    //     ]
    // },
    {
      name: 'Badge Icons',
      description: 'Create badge icons and associate them with collections',
      url: '/badges',
      icon: <BeenhereIcon />,
      //     sub: [
      //         {
      //             name: 'Create Badge Icons',
      //             description: 'Create Badge Icons',
      //             icon: <AddIcon />,
      //             url: '/badge-icons/create'
      //         },
      //         {
      //             name: 'List Badge Icons',
      //             description: 'List Badge Icons',
      //             icon: <ListIcon />,
      //             url: '/badge-icons/list'
      //         },
      //     ]
    },
    {
      name: 'Banners & Sliders',
      description: 'Create and view banners and schedule banners',
      icon: <SlideshowIcon />,
      url: '/banner',
      sub: [
        {
          name: 'Banners',
          description: 'Banners',
          icon: <ViewListIcon />,
          url: '/banner',
        },
        {
          name: 'Banner Sliders',
          description: 'Banner Sliders',
          icon: <ListIcon />,
          url: '/banner-slider',
        },
      ],
    },
    {
      name: 'Categories',
      description: 'Edit and add Categories',
      url: '/category',
      icon: <CategoryIcon />,
    },
    {
      name: 'Collection Types',
      description: 'Create and edit Collections Types',
      url: '/collection-types',
      icon: <CollectionsBookmarkIcon />,
      //     sub: [
      //         {
      //             name: 'Create Collection Type',
      //             description: 'Create Collection Type',
      //             icon: <AddIcon />,
      //             url: '/collection-types/create'
      //         },
      //         {
      //             name: 'List Colleciton Types',
      //             description: 'List Colleciton Types',
      //             icon: <ListIcon />,
      //             url: '/collection-types/list'
      //         },
      //     ]
    },
    {
      name: 'Collections - Videos',
      description: 'Create and edit video collections',
      url: '/collection-videos',
      icon: <CollectionsBookmarkIcon />,
    },
    {
      name: 'Collections - Photos',
      description: 'Create and edit photo collections',
      url: '/collection-photos',
      icon: <CollectionsBookmarkIcon />,
    },
    {
      name: 'Comments',
      description: 'Delete comments',
      url: '/comment-media',
      icon: <CommentIcon />,
    },
    {
      name: 'Contests',
      description: 'Create and edit Contests',
      url: '/contest',
      icon: <CompareIcon />,
      sub: [
        {
          name: 'Contest',
          description: 'Contest',
          icon: <ListIcon />,
          url: '/contest',
        },
        {
          name: 'Contest Type',
          description: 'Contest Type',
          icon: <ViewListIcon />,
          url: '/contest-type',
        },
      ],
    },

    {
      name: 'Drone TV',
      description: 'Make Changes in Drone TV',
      icon: <TvIcon />,
      url: '/tv',
      sub: [
        {
          name: 'View Current List',
          description: 'View Collection Type in Drone TV',
          icon: <MovieIcon />,
          url: '/tv',
        },
        {
          name: 'Feature Box',
          description: 'Edit Feature Box (Big Image on TV App)',
          icon: <TvTwoToneIcon />,
          url: '/tv/feature',
        },
      ],
    },
    {
      name: 'Media Mention',
      description: 'Media Mention List',
      url: '/media-mentions',
      icon: <MessageIcon />,
    },
    {
      name: 'Message',
      description: 'Notification and messaging',
      url: '/message',
      icon: <MessageIcon />,
      sub: [
        {
          name: 'Notification',
          description: 'Send notification to user',
          icon: <NotificationsIcon />,
          url: '/message/notification',
        },
      ],
    },
    {
      name: 'Feature Box',
      description: 'Create and edit Feature Box and Feature Box Location',
      url: '/feature-box',
      icon: <FeaturedVideoIcon />,
      sub: [
        {
          name: 'Feature Box',
          description: 'Feature Box and add Feature Box',
          icon: <FeaturedPlayListIcon />,
          url: '/feature-box',
        },
        {
          name: 'Feature Box Location',
          description: 'List Feature Box',
          icon: <FeaturedVideoOutlinedIcon />,
          url: '/feature-box-location',
        },
        //         {
        //             name: 'Create Feature Box Location',
        //             description: 'Create Feature Box Location',
        //             icon: <AddToPhotosIcon />,
        //             url: '/feature-box/create-location'
        //         },
        //         {
        //             name: 'List Feature Box Location',
        //             description: 'List Feature Box Location',
        //             icon: <ViewListIcon />,
        //             url: '/feature-box/list-location'
        //         },
      ],
    },
    // {
    //     name: 'Featured Videos',
    //     description: 'Add or remove Featured Videos',
    //     icon: <RadioIcon />,
    //     url: '/featured-video'
    // },
    {
      name: 'History',
      description: 'View changes done to videos, collections, and more',
      icon: <HistoryIcon />,
      url: '/history',
    },
    {
      name: 'Partners',
      description: 'Add or edit external partners that work with AirVuz',
      icon: <PeopleOutlineIcon />,
      url: '/partners',
      sub: [
        {
          name: 'Partners',
          description: 'Partners',
          icon: <ViewListIcon />,
          url: '/partners',
        },
        {
          name: 'Exclusive',
          description: 'Exlusive Partners',
          icon: <ListIcon />,
          url: '/partners/exclusive',
        },
      ],
    },
    // {
    //   name: "Media Mention",
    //   description: "Control the Media Mention content",
    //   icon: <ArtTrackIcon />,
    //   url: "/media-mentions",
    // },
    {
      name: 'News',
      description: 'View and edit the News Landing Page and the News Collections',
      icon: <RadioIcon />,
      url:
        process.env.REACT_APP_NODE_ENV_TYPE === 'prod'
          ? '/collection-types/edit/5c780b173eaffc08707ce6b5' // prod
          : '/collection-types/edit/5c45eb0ce256550a022b59ed', // beta / localhost
    },
    {
      name: 'Photo',
      description: 'Search for photos and curate photo',
      url: '/photo',
      icon: <PhotoIcon />,
    },
    // {
    //     name: "Photo Collection",
    //     description: "Create and edit photo collections",
    //     url: "/photo-collection",
    //     icon: <PhotoLibraryIcon />
    // },
    {
      name: 'Reports',
      description: 'Contain reports',
      url: '/reports',
      icon: <ReportIcon />,
      sub: [
        {
          name: 'AirVuz / DroneTV Library of Content',
          description: 'AirVuz and DroneTV Library Report',
          icon: <RssFeedIcon />,
          url: '/reports/AirVuz-MRSS',
        },
        // {
        //     name: 'Comments & No Video Uploads',
        //     description: 'Comments & No Video Uploads',
        //     icon: <CommentIcon />,
        //     url: '/reports/comments-no-video'
        // },
        // {
        //     name: 'Comments by User',
        //     description: 'Comments by User',
        //     icon: <CommentIcon />,
        //     url: '/reports/comments-user'
        // },
        {
          name: 'Contributor Report',
          description: 'Employee and Contributor Report',
          icon: <GroupIcon />,
          url: '/reports/contributor',
        },
        // {
        //     name: 'Last Video Uploaded x Days Ago',
        //     description: 'Last Video Uploaded x Days Ago',
        //     icon: <FeaturedVideoIcon />,
        //     url: '/reports/last-video-upload-days'
        // },
        {
          name: 'Partner Report',
          description: 'Partner Report',
          icon: <PeopleOutlineIcon />,
          url: '/reports/partner',
        },
        {
          name: 'Social Media Share Report',
          description: 'Get share report by media created with in date range',
          icon: <ShareIcon />,
          url: '/reports/social-media-share',
        },
        // {
        //     name: 'Photos Uploaded',
        //     description: 'Photos Uploaded',
        //     icon: <PhotoIcon />,
        //     url: '/reports/photos-upload'
        // },
        // {
        //     name: 'Returning Content Creators',
        //     description: 'Returning Content Creators',
        //     icon: <PersonPinIcon />,
        //     url: '/reports/returning-creator'
        // },
        // {
        //     name: 'Shared Videos',
        //     description: 'Shared Videos',
        //     icon: <ShareIcon />,
        //     url: '/reports/shared-videos'
        // },
        {
          name: 'Site Info',
          description: 'Site Info',
          icon: <TimelineIcon />,
          url: '/reports/site-info',
        },
        // {
        //     name: 'New User Report',
        //     description: 'New User Report for a date range',
        //     icon: <PersonAddIcon />,
        //     url: '/reports/new-user'
        // },
        {
          name: 'New Contributor Report',
          description: 'New Contributor and User Report for a date range',
          icon: <PersonAddIcon />,
          url: '/reports/new-contributor',
        },
        // {
        //     name: 'New Video Contributor Report',
        //     description: 'New Video Contributor Report for a date range',
        //     icon: <PersonAddIcon />,
        //     url: '/reports/new-video-contributor'
        // },
        // {
        //     name: 'Videos Bad Words',
        //     description: 'Videos Bad Words',
        //     icon: <CommentIcon />,
        //     url: '/reports/video-word'
        // },
        // {
        //     name: 'Videos Curated',
        //     description: 'Videos Curated',
        //     icon: <OndemandVideoIcon />,
        //     url: '/reports/video-curated'
        // },
        {
          name: 'Videos Deleted',
          description: 'Videos Deleted',
          icon: <FeaturedVideoIcon />,
          url: '/reports/video-deleted',
        },
        {
          name: 'Heavily Commented Media',
          description: 'Media that is heavily commented',
          icon: <CommentIcon />,
          url: '/reports/heavily-commented-media',
        },
        {
          name: 'Videos Feature Eligible',
          description: 'Videos Feature Eligible',
          icon: <FeaturedVideoIcon />,
          url: '/reports/video-feature-eligible',
        },
        {
          name: 'Missing Contributor',
          description: 'Get missing contributor report by days since last upload',
          icon: <AssessmentIcon />,
          url: '/reports/missing-contributor',
        },
        {
          name: 'MRSS Report',
          description: 'Get MRSS Feed Report',
          icon: <RssFeedIcon />,
          url: '/reports/mrss',
        },
        {
          name: 'Uploads Report',
          description: 'Get Upload Report',
          icon: <PublishIcon />,
          url: '/reports/uploads',
        },
        {
          name: 'MRSS Media Library Report',
          description: 'Get MRSS Media Library report',
          icon: <RssFeedIcon />,
          url: '/reports/mrss-media-library',
        },
        {
          name: 'MRSS Media Series Report',
          description: 'Get MRSS Media Series report',
          icon: <RssFeedIcon />,
          url: '/reports/mrss-media-series',
        },
        // {
        //     name: 'Video Shares',
        //     description: 'Video Shares',
        //     icon: <ShareIcon />,
        //     url: '/reports/video-shares'
        // },
        // {
        //     name: 'Videos Shared',
        //     description: 'Videos Shared',
        //     icon: <ShareIcon />,
        //     url: '/reports/video-shared'
        // },
        // {
        //     name: 'Video Uploaded',
        //     description: 'Video Uploaded',
        //     icon: <PublishIcon />,
        //     url: '/reports/video-uploaded'
        // },
        // {
        //     name: 'Videos Uploaded by Contributor',
        //     description: 'Videos Uploaded by Contributor',
        //     icon: <PublishIcon />,
        //     url: '/reports/video-by-contributor'
        // },
      ],
    },
    {
      name: 'RSS',
      description: 'Manage MRSS and Podcast',
      icon: <RssFeedIcon />,
      url: '/rss',
      sub: [
        {
          name: 'MRSS',
          description: 'MRSS and MRSS Media',
          icon: <CastConnectedIcon />,
          url: '/rss/mrss',
        },
        {
          name: 'Podcast',
          description: 'Podcast and different podcast format',
          disabled: true,
          icon: <CastIcon />,
          url: '/rss/podcast',
        },
      ],
    },
    {
      name: 'Upload',
      description: 'view upload progress',
      icon: <CloudUploadIcon />,
      url: '/upload',
    },
    {
      name: 'User',
      description: 'Search and edit User info and  access',
      icon: <AccountCircleIcon />,
      url: '/user',
    },
    {
      name: 'Video',
      description: 'Search, curated, and reupload videos',
      icon: <OndemandVideoIcon />,
      url: '/video',
    },
    {
      name: 'Bulk',
      description: 'Bulk tasks',
      icon: <CategoryIcon />,
      url: '/bulk',
      sub: [
        {
          name: 'Video Download',
          description: 'bulk video download',
          icon: <ListIcon />,
          url: '/bulk/video-download',
        },
      ],
    },
  ];

  // APP FEATURE ROLES
  let root = havePermission(identity, 'root');
  let autoview = havePermission(identity, 'autoviews-create');
  let judge = havePermission(identity, 'admin-judge');
  if (root) {
    // Add only root user feature
    features = [...features, ...APP_ROOT_FEATURE];
  }
  if (root || autoview) {
    // add autoview user feature
    features = [...features, ...APP_AUTOVIEW_FEATURE];
  }
  if (root || judge) {
    // add judge user feature
    features = [...features].map((f) => {
      if (f.name === 'Reports') {
        f.sub = [...f.sub, ...APP_JUDGE_FEATURE_REPORT];
      }
      return f;
    });
    features = [...features, ...APP_JUDGE_FEATURE];
  }
  // APP FEATURE ROLES
  return features;
};

export default APP_FEATURES;
